/**
 * @module useAttendanceSettings
 * @desc This hook is used to fetch the attendance settings from the server.
 * @param {string} classUuid - The UUID of the class.
 * @returns {Object} - The attendance settings.
 */

import { type UseQueryResult } from '@tanstack/react-query';

import { useApiEndpointGet } from './useApiEndpointGet';
import { GET_MERGED_CLASS_SETTINGS } from '../config/apiPaths';
import { type AttendanceSettings } from '../types/adminConfig';
import { type SchoolSettings } from '../types/apiTypes';
import { mergeAttendanceSettings } from '../utils/typeUtils';

const useAttendanceSettingsQuery = (classUuid: string, userUuid: string): UseQueryResult<AttendanceSettings> =>
    useApiEndpointGet<SchoolSettings, AttendanceSettings>({
        userUuid,
        apiPath: GET_MERGED_CLASS_SETTINGS,
        enabled: !!classUuid && !!userUuid,
        queryKeyAttributes: [classUuid],
        params: { class_uuid: classUuid },
        transformer: (data) => mergeAttendanceSettings(data) as AttendanceSettings
    });

export default useAttendanceSettingsQuery;
